var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('INavbar',{staticClass:"blur",attrs:{"role":"navigation"}}),_c('div',{staticClass:"blur img-container"}),_c('i-register-dialog',{attrs:{"visible":_vm.isRegisterDialogVisible}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }